
import { Skeleton } from "antd";

import styles from "./ProjectHeader.module.scss";

export const ProjectHeaderPlaceholder = () => {
  return (
    <div className={styles.root}>
      <Skeleton active paragraph={{ rows: 1 }} />
        <div className={styles.infoWrapper}>
          <Skeleton.Button active />
          <Skeleton.Button active />
          <Skeleton.Button active />
          <Skeleton.Button active />
        </div>
    </div>
  );
};
